module.exports = __webpack_public_path__ + "img/mission_intro_bg.8ac66ab3.png";